import { render, staticRenderFns } from "./renovacao-online.vue?vue&type=template&id=569e8666&scoped=true"
import script from "./renovacao-online.vue?vue&type=script&lang=js"
export * from "./renovacao-online.vue?vue&type=script&lang=js"
import style0 from "./renovacao-online.vue?vue&type=style&index=0&id=569e8666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569e8666",
  null
  
)

export default component.exports